var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"img-fluid",attrs:{"autoplay":_vm.autoplay,"controls":_vm.controls,"loop":_vm.loop,"playsinline":""},domProps:{"muted":_vm.muted}},[_c('source',{attrs:{"src":_vm.webmUrl,"type":"video/webm"}}),_c('source',{attrs:{"src":_vm.mp4Url,"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }